import React, { useState } from 'react';
import { Tooltip } from '@mui/material';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import { fontSize, palette } from '../../..';
import { useSelector, useDispatch } from 'react-redux';
import { RootState } from '../../../redux';
import ChartFilterGroupMenu from './ChartFilterGroupMenu';
import { setSelectedControlMenu } from '../../../redux/TabTile/TabTileActionsAndMultipleDispatches';
import { KeyboardArrowDown } from '@mui/icons-material';

interface Props {
  propKey: string;
  fromDashboard: boolean;
  reportFilterMenu?: boolean;
  setReportFilterMenu?: (value: boolean) => void;
  manualReportFilterMenu?: boolean;
  setManualReportFilterMenu?: (value: boolean) => void;

  backgroundColor?: string;
  color?: string;
}

const ReportFilterHeaderWithGroupMenu = ({
  propKey,
  fromDashboard,
  reportFilterMenu,
  setReportFilterMenu,
  manualReportFilterMenu,
  setManualReportFilterMenu,

  backgroundColor,
  color,
}: Props) => {
  const [anchorEl, setAnchorEl] = useState<null | Element>(null);

  const { tabTileProps } = useSelector((state: RootState) => ({
    tabTileProps: state.tabTileProps,
  }));

  const dispatch = useDispatch();

  const isEdit = tabTileProps.dashMode === 'Edit';
  const isPresent = tabTileProps.dashMode === 'Present';

  // Unified flag for whether dropdown is open
  const isOpen = isPresent ? reportFilterMenu : manualReportFilterMenu;

  const handleMenuToggle = () => {
    if (isEdit && setManualReportFilterMenu) {
      setManualReportFilterMenu(!manualReportFilterMenu); // Manual toggle in Edit
    } else if (isPresent && setReportFilterMenu) {
      setReportFilterMenu(!reportFilterMenu); // Global toggle in Present
    }
  };

  return (
    <div
      style={{
        color: color,
        fontWeight: '600',
        padding: '0 0 0 0',
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        fontSize: '0.875rem',
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '0.5rem',
        }}
      >
        <span style={{ fontSize: fontSize.large, color: color }}>Report Filter</span>
      </div>

      <div
        style={{
          display: 'flex',
          columnGap: '5px',
          alignItems: 'center',
          justifyContent: 'flex-end',
          marginRight: '0.92rem',
        }}
      >
        <MoreVertIcon
          onClick={(event) => {
            setAnchorEl(event.currentTarget);
            // if (isEdit && setManualReportFilterMenu) {
            //   setManualReportFilterMenu(!manualReportFilterMenu);
            // }
          }}
          style={{
            height: '16px',
            width: '16px',
            color: color,
            cursor: 'pointer',
          }}
        />

        <Tooltip
          title={isOpen ? 'Hide' : 'Show'}
          slotProps={{
            tooltip: {
              sx: {
                fontSize: '12px',
              },
            },
          }}
        >
          {isOpen ? (
            <KeyboardArrowUpIcon
              sx={{ fontSize: '18px', float: 'right', transform: 'translateX(-2px)', color: color }}
              onClick={handleMenuToggle}
            />
          ) : (
            <KeyboardArrowDown
              sx={{ fontSize: '18px', float: 'right', transform: 'translateX(-2px)', color: color }}
              onClick={handleMenuToggle}
            />
          )}
        </Tooltip>

        <ChartFilterGroupMenu
          propKey={propKey}
          fromDashboard={fromDashboard}
          anchorEl={anchorEl}
          setAnchorEl={setAnchorEl}
        />
      </div>
    </div>
  );
};

export default ReportFilterHeaderWithGroupMenu;
